<div class="img__background">
  @if (isDatoImage()) {
    <img class="img__container" [src]="src()" [alt]="alt()" datoImage [imgixWidth]="width()" />
  } @else {
    <img class="img__container" [src]="src()" [alt]="alt()" />
  }
</div>
